import destr from "destr";
export function setDefaultMetaRobots(meta_robots = []) {
  meta_robots = !Array.isArray(meta_robots) ? destr(meta_robots) : meta_robots;
  meta_robots = Array.isArray(meta_robots) ? meta_robots : [];
  meta_robots = !meta_robots?.includes("nofollow") ? [...meta_robots, "follow"] : meta_robots;
  meta_robots = !meta_robots?.includes("noindex") ? [...meta_robots, "index"] : meta_robots;
  return [...new Set(meta_robots)];
}
export function stripTag(str = "") {
  return str?.replace(/<[^>]*>?/gm, "").replaceAll("\n", " ")?.substring(0, 255);
}
